import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { MaterialModule } from "../material/material.module";
import { ConfirmationService } from "./confirmation.service";
import { SharedModule } from "../shared/shared.module";

@NgModule({
  imports: [CommonModule, MaterialModule, SharedModule],
  declarations: [ConfirmationDialogComponent],
  providers: [ConfirmationService],
})
export class ConfirmationDialogModule {}
